import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { videos } from "@/mocks/videos";
import { formatCount } from "@/utils/format";

export default function HeroCarousel() {
  const featured = videos.slice(0, 5);
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setIndex((prev) => (prev + 1) % featured.length);
    }, 5000);
    return () => clearInterval(timer);
  }, [featured.length]);

  const goPrev = () => setIndex((prev) => (prev - 1 + featured.length) % featured.length);
  const goNext = () => setIndex((prev) => (prev + 1) % featured.length);

  return (
    <section className="w-full px-4 pt-6 md:px-8 md:pt-8">
      <div className="relative w-full overflow-hidden rounded-lg bg-foreground-950">
        <div className="relative h-[380px] w-full md:h-[560px]">
          {featured.map((video, i) => (
            <div
              key={video.id}
              className={`absolute inset-0 transition-opacity duration-700 ${
                i === index ? "opacity-100" : "pointer-events-none opacity-0"
              }`}
            >
              <img
                src={video.cover}
                alt={video.title}
                title={`${video.title} 吃瓜视频`}
                className="h-full w-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/90 via-foreground-950/45 to-foreground-950/20" />
            </div>
          ))}

          <div className="absolute inset-x-0 bottom-0 p-5 md:p-10">
            <div className="max-w-3xl">
              <div className="mb-3 flex flex-wrap items-center gap-2">
                <span className="rounded bg-primary-500 px-2.5 py-1 text-xs font-medium text-background-50">
                  {featured[index].categoryName}
                </span>
                <span className="rounded bg-background-50/20 px-2.5 py-1 text-xs font-medium text-background-50 backdrop-blur">
                  焦点推荐
                </span>
                <span className="flex items-center gap-1 text-xs text-background-50/80">
                  <span className="flex h-3.5 w-3.5 items-center justify-center">
                    <i className="ri-fire-line text-sm" />
                  </span>
                  {formatCount(featured[index].views)} 次播放
                </span>
              </div>
              <h1 className="font-heading text-2xl font-black leading-tight text-background-50 md:text-4xl">
                {featured[index].title}
              </h1>
              <p className="mt-3 line-clamp-2 text-sm leading-6 text-background-50/85 md:text-base">
                {featured[index].summary}
              </p>
              <div className="mt-5 flex flex-wrap items-center gap-3">
                <Link
                  to={`/detail/${featured[index].id}`}
                  className="flex items-center gap-2 rounded-md bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 whitespace-nowrap"
                >
                  <span className="flex h-4 w-4 items-center justify-center">
                    <i className="ri-play-fill text-lg" />
                  </span>
                  立即观看
                </Link>
                <Link
                  to={`/category/${featured[index].categoryId}`}
                  className="flex items-center gap-2 rounded-md border border-background-50/40 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-background-50/15 whitespace-nowrap"
                >
                  进入分类
                </Link>
              </div>
            </div>
          </div>

          <button
            type="button"
            onClick={goPrev}
            aria-label="上一个"
            className="absolute left-3 top-1/2 hidden h-10 w-10 -translate-y-1/2 items-center justify-center rounded-full bg-background-50/25 text-background-50 backdrop-blur transition-colors hover:bg-background-50/40 md:flex"
          >
            <i className="ri-arrow-left-s-line text-2xl" />
          </button>
          <button
            type="button"
            onClick={goNext}
            aria-label="下一个"
            className="absolute right-3 top-1/2 hidden h-10 w-10 -translate-y-1/2 items-center justify-center rounded-full bg-background-50/25 text-background-50 backdrop-blur transition-colors hover:bg-background-50/40 md:flex"
          >
            <i className="ri-arrow-right-s-line text-2xl" />
          </button>

          <div className="absolute right-5 top-5 flex items-center gap-1.5 md:right-10 md:top-8">
            {featured.map((video, i) => (
              <button
                key={video.id}
                type="button"
                aria-label={`切换到第 ${i + 1} 个`}
                onClick={() => setIndex(i)}
                className={`h-1.5 rounded-full transition-all ${
                  i === index ? "w-6 bg-primary-500" : "w-1.5 bg-background-50/60 hover:bg-background-50"
                }`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}